import React from 'react';

const StepIcon = ({ color, step }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <circle cx="16" cy="16" r="16" fill={color.circleColor} stroke={color.borderColor} />
    <text
      x="50%"
      y="50%"
      textAnchor="middle"
      stroke={color.textColor}
      dy=".3em"
      fontSize="13px"
      fontStyle="normal"
      fontWeight="500"
      fontFamily="Montserrat"
    >
      {step}
    </text>
  </svg>
);

export default StepIcon;
